import shortNumber from './shortNumber';
import formatDate from './formatDate';
import timeAgo from './timeAgo';

export default {
  install(Vue) {
    Vue.filter('shortNumber', shortNumber);
    Vue.filter('formatDate', formatDate);
    Vue.filter('timeAgo', timeAgo);
  },
};
